<script setup lang="ts">
import bubbles from '~/assets/images/bubbles/firefly-bubbles@2x.webp'

const props = defineProps<{
  data: SectionTeamRecord
  moduleIndex: number
}>()

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)

const { isDesktop } = useDevice()
const store = useAppStore()

const members = ref(store.allTeamMembers)

// Add CMS Overrides
if (Array.isArray(props.data.records) && props.data.records.length) {
  members.value.unshift(...props.data.records)
  members.value = members.value.slice(0, props.data.records.length)
}
</script>

<template>
  <div class="w-full overflow-hidden pb-12 pt-header-h lg:pb-20 lg:pt-40" :class="invertedStyles">
    <LazyImage
      v-if="isDesktop"
      loading="lazy"
      class="absolute -bottom-28 -left-48 hidden aspect-square object-contain lg:block"
      :src="bubbles"
      :width="896"
      :height="896"
      alt=""
    />
    <DeliciousSausage
      v-if="isDesktop"
      name="services-medium"
      class="absolute -left-96 bottom-80 hidden -rotate-45 lg:block xl:-left-80"
    />
    <div class="container">
      <Heading
        v-if="data.title"
        class="mb-8 max-w-[840px] uppercase lg:mb-44"
        :level="level"
        :size="2"
        :is-semantic="isSemantic"
      >
        <TextReveal>
          {{ data.title }}
        </TextReveal>
      </Heading>
    </div>
    <div class="grid-default relative pl-4">
      <div class="col-span-full -ml-4 !w-[100%+16px] lg:col-span-9 lg:col-start-4">
        <div class="mb-4 pl-4 font-bold">Meet the Team</div>
        <TeamSlider v-if="members?.length" :data="members" />
        <NuxtLink
          v-if="data.button"
          :to="data.button?.reference?.slug"
          class="mx-auto mt-4 block w-fit bg-black px-6 py-2.5 text-white lg:ml-4 lg:mt-13"
        >
          {{ data.button.label }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
